import * as Sentry from '@sentry/react';
import type { AnyRouter } from '@tanstack/react-router';

import { router } from '@/libs/router.service';

export function initSentry(): void {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: __APP_STAGE__,
    release: __APP_VERSION__,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router, { instrumentNavigation: false }),
    ],
    tracesSampleRate: 0,
  });

  nameTransactionAfterResolvedRoute(router);
}

export function nameTransactionAfterResolvedRoute(routerInstance: AnyRouter): () => void {
  return routerInstance.subscribe('onResolved', ({ toLocation }) => {
    const matches = routerInstance.matchRoutes(toLocation.pathname, toLocation.search, {
      preload: false,
      throwOnError: false,
    });
    const lastMatch = matches[matches.length - 1];

    Sentry.getCurrentScope().setTransactionName(lastMatch?.routeId ?? toLocation.pathname);
  });
}

const LEGACY_HOSTNAME = 'bank-details-form.hikoala.co';

export function reportLegacyDomainUsage(): void {
  if (window.location.hostname !== LEGACY_HOSTNAME) {
    return;
  }

  Sentry.captureMessage('Legacy bank-details-form domain used', {
    level: 'warning',
    tags: { legacyDomain: LEGACY_HOSTNAME },
    extra: { path: window.location.pathname, referrer: document.referrer },
  });
}

export { Sentry };
